import { useEffect, useRef, useState } from 'react';
import { tsdiInjector } from './tsdi-injector';
function getComponentOptions(Dependency) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const componentOptions = typeof Dependency !== 'string' &&
        Reflect.getMetadata('component:options', Dependency);
    return componentOptions || {};
}
const TSDI_MAP = Symbol('tsdi_dependencies');
export function injectTSDI(Dependency, instance) {
    const componentOptions = getComponentOptions(Dependency);
    const refInstance = instance;
    if (componentOptions.singleton === false && !refInstance) {
        // eslint-disable-next-line ml-rules/rules-of-hooks-in-observer,react-hooks/rules-of-hooks
        return useTSDI(Dependency);
    }
    if (componentOptions.singleton === false && refInstance) {
        const tsdiMap = refInstance[TSDI_MAP] ?? new Map();
        const mapDep = tsdiMap.get(Dependency);
        if (mapDep) {
            return mapDep;
        }
        const dep = tsdiInjector.get(Dependency);
        tsdiMap.set(Dependency, dep);
        refInstance[TSDI_MAP] = tsdiMap;
        return dep;
    }
    return tsdiInjector.get(Dependency);
}
/**
 * @deprecated use injectTSDI instead
 */
export function useTSDI(Dependency) {
    const dep = tsdiInjector.get(Dependency);
    const depState = useRef(dep);
    const componentOptions = getComponentOptions(Dependency);
    if (componentOptions.singleton === false) {
        return depState.current;
    }
    return dep;
}
class ScopesCountManager {
    scopes = {};
    getScopeCount(scope) {
        return this.scopes[scope] ?? 0;
    }
    onEnterScope(scope) {
        const count = this.getScopeCount(scope) + 1;
        this.scopes[scope] = count;
        if (count === 1) {
            tsdiInjector.getScope(scope).enter();
        }
    }
    onLeaveScope(scope) {
        const count = this.getScopeCount(scope) - 1;
        this.scopes[scope] = count;
        if (count === 0) {
            tsdiInjector.getScope(scope).leave();
        }
    }
}
const scopesCountManager = new ScopesCountManager();
export function useScope(scope) {
    const [entered, setEntered] = useState(false);
    if (!entered) {
        setEntered(true);
        scopesCountManager.onEnterScope(scope);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => scopesCountManager.onLeaveScope(scope), []);
}
